module.exports = __webpack_public_path__ + "static/media/Artboard7.ef8039f8.svg";